import React, { useState } from "react";
import ModalComponent from "../../../ModalComponent";
import VideoRecorder from "react-video-recorder";
import { postMethod } from "../../../../api/HTTPServices";

const Index = ({
  handleOpenVideoRecording,
  handleCloseVideoRecording,
  audienceId,
  visitToken,
  addMessageToList,
  attachType,
}) => {
  // const [ sendConfirm, setSendConfirm ] = useState(false);
  const [videoBlob, setVideoBlob] = useState();
  // const [loading, setLoading] = useState(false);

  const upLoadVideo = () => {
    // setLoading(true);
    // const file = new File([ videoBlob ], `${Math.random()}.mp4`);
    if (videoBlob) {
      let data = new FormData();
      data.append("file", videoBlob);
      data.append("audience", audienceId);
      if (attachType === "prescription") {
        data.append("type", "prescriptionVideoMessage");
      } else {
        data.append("type", "dossierVideoMessage");
      }
      data.append("room_token", visitToken);

      const RequestService = postMethod(
        "chat",
        data,
        "true",
        "post",
        "false",
        "",
        false
      );
      RequestService.then(function (response) {
        if (response) {
          // setLoading(false);
          handleCloseVideoRecording();
          addMessageToList(response.message);
          // setSendConfirm(false);
        }
      });
    } else {
      alert("no recorded video, first record a video");
    }
  };
  return (
    <ModalComponent
      open={handleOpenVideoRecording}
      handleClose={handleCloseVideoRecording}
      closeBtn={true}
      confirmBtn={true}
      handleOk={upLoadVideo}
      title="take a video"
    >
      <div>
        <VideoRecorder
          onRecordingComplete={(video) => {
            setVideoBlob(video);
          }}
        />
      </div>
    </ModalComponent>
  );
};

export default Index;
